var exports = {
  "az": "Box__AuMIuB",
  "EY": "Text__40j-Fb",
  "UE": "Text_1__sDbWaT",
};

module.exports = exports;
